// extracted by mini-css-extract-plugin
module.exports = {"Loader":"style_Loader__2JZWP","Loader-first":"style_Loader-first__2IFIf","loaderRotation":"style_loaderRotation__3gBef","Loader-second":"style_Loader-second__QQzUv"};